import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authActions } from './auth';

interface CustomFieldState {
  selectedCustomerId: string | null;
  selectedEntityId: string | null;
}

const initialState: CustomFieldState = {
  selectedCustomerId: null,
  selectedEntityId: null,
};

const customFieldSlice = createSlice({
  name: 'customField',
  initialState,
  reducers: {
    setCustomFieldSelection(state, action: PayloadAction<{ customerId: string | null; entityId: string | null }>) {
      state.selectedCustomerId = action.payload.customerId;
      state.selectedEntityId = action.payload.entityId;
    },
    clearCustomFieldSelection(state) {
      state.selectedCustomerId = null;
      state.selectedEntityId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authActions.logout, () => {
      return initialState;
    });
  },
});

export const { setCustomFieldSelection, clearCustomFieldSelection } = customFieldSlice.actions;
export default customFieldSlice.reducer;
